import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useRealtimeEvent, type UserEvent } from '@/features/realtime/RealtimeProvider';
import { availableNowKey } from '@/features/sessions/hooks/useNowAvailableHelpliners';

import { portalHelplineKeys } from './useCallablePractitioners';

/**
 * App-root listener: a `helpline.availability-changed` event invalidates the
 * resolved available-now list and the callable-practitioner lists (both roles
 * via the `['portal-helpline']` prefix). When the wizard isn't mounted these
 * are no-ops. `available` on the payload is a hint only — always refetch.
 */
export function useHelplineAvailabilityListener(): void {
  const queryClient = useQueryClient();
  const handler = useCallback(
    (_event: Extract<UserEvent, { type: 'helpline.availability-changed' }>) => {
      void queryClient.invalidateQueries({ queryKey: availableNowKey });
      void queryClient.invalidateQueries({ queryKey: portalHelplineKeys.all });
    },
    [queryClient],
  );
  useRealtimeEvent('helpline.availability-changed', handler);
}
